export default __webpack_public_path__ + "static/Mallorie-Regular-d4040700a153daf8304ae7b87dc315f7.woff";